<template>
  <section class="projects">
    <Container>
      <Title tag="h2" class="is-centered">Proyectos</Title>
      <Row>
        <ColumnUi md="6" lg="6" class="project">
          <div class="icon-wrapper">
            <Icon svg="folder" class="project__icon" />
          </div>
          <div class="project__info">
            <h3 class="project__title">Proyectos de Investigación</h3>
            <span><Button tag="router-link" to="/proyectos/investigacion" theme="primary">Conoce más</Button></span>
          </div>
        </ColumnUi>
        <ColumnUi md="6" lg="6" class="project">
          <div class="icon-wrapper">
            <Icon svg="folder" class="project__icon" />
          </div>
          <div class="project__info">
            <h3 class="project__title">
              Proyectos de Presupuesto por Resultados
            </h3>
            <span><Button tag="router-link" to="/proyectos/ppr" theme="primary">Conoce más</Button></span>
          </div>
        </ColumnUi>
      </Row>
    </Container>
  </section>
</template>
<script>
import Container from "@/components/ui/objects/Container";
import Button from "@/components/ui/atoms/Button";
import Icon from "@/components/ui/atoms/Icon";
import Row from "../ui/atoms/Row.vue";
import ColumnUi from "../ui/atoms/ColumnUi.vue";
import Title from "../ui/atoms/Title.vue";
export default {
  components: {
    Container,
    Button,
    Icon,
    Row,
    ColumnUi,
    Title
  }
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
@use "@/assets/styles/tools/_mixins.scss";
.projects {
  padding: variables.$spacing-l 0;
}
.project {
  display: flex;
  align-items: center;
  grid-gap: 0 1.5em;
  margin-bottom: 2em;
  .icon-wrapper {
    min-width: 100px;
    height: 100px;
    background-color: variables.$primary-color;
    border-radius: 50%;
    @include mixins.centered;
  }
  &__info {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  &__icon {
    height: 3em;
    fill: variables.$text-inverted-color;
    margin: 0;
  }
}
@media (min-width: variables.$lg) {
  .project {
    margin-bottom: 0;
  }
}
</style>
